import styled from "styled-components";

export const ButtonRow = styled.div`
  padding: 0px;
  display: inherit;
  /* position: relative;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition); */
`;

export const ContainerDaily = styled.div`
  border: 1px solid #ccc;
  padding: 10px 15px;
  border-radius: 5px;
  -webkit-box-shadow: 10px 12px 15px -6px rgba(0, 0, 0, 0.33);
  -moz-box-shadow: 10px 12px 15px -6px rgba(0, 0, 0, 0.33);
  box-shadow: 10px 12px 15px -6px rgba(0, 0, 0, 0.33);
  margin-bottom: 20px;
`;

export const Label = styled.div`
  font-weight: bold;
  font-size: 0.9rem;
  margin-right: 10px;
`;

export const Value = styled.div`
  font-size: 0.875rem;
`;

export const TitleSection = styled.div`
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const HeadListTask = styled.div`
  background-color: #6ec1e4;
  color: #fff;
  padding-top: 5px;
  padding-bottom: 5px;
`;

export const EditButton = styled.button`
  border: 0px;
  background-color: #6ec1e4;
  color: #fff;
  border-radius: 5px;
  font-size: 1rem;
  height: 35px;
  width: 35px;

  &:hover {
    background-color: #63accc;
  }
`;

export const DeleteButton = styled.button`
  border: 0px;
  background-color: #d6475f;
  color: #fff;
  border-radius: 5px;
  font-size: 1rem;
  height: 35px;
  width: 35px;

  &:hover {
    background-color: #e94c66;
  }
`;

export const ValueWithBack = styled.span`
  background-color: #d6475f;
  color: #fff;
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 0.75rem;
`;

export const ValueRow = styled.span`
  background-color: #d7bb33;
  color: #333;
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 0.75rem;
  margin-right: 5px;
`;
